import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { reelService } from '../services/api';
import '../styles/Home.css';

const Home = () => {
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReels = async () => {
      try {
        const res = await reelService.getAllReels(20, 0);
        const reelsData = Array.isArray(res.data) ? res.data : res.data.reels || [];
        setReels(reelsData);
      } catch (err) {
        console.error('Error fetching reels:', err);
        setReels([]);
      } finally {
        setLoading(false);
      }
    };
    fetchReels();
  }, []);



  if (loading) {
    return <div className="home-loading">Loading reels...</div>;
  }

  return (
    <div className="home">
      <div className="home-header">
        <h1>Popular Reels</h1>
        <p>Swipe to explore</p>
      </div>
      <div className="reels-grid">
        {reels.map((reel) => (
          <div key={reel.id} className="reel-card" onClick={() => navigate(`/reels/${reel.category_id}`)}>
            <video
              src={encodeURI(reel.video_url)}
              className="reel-card-video"
              muted
              onError={e => console.error('Video failed to load:', reel.video_url, e)}
            />
            <div className="reel-card-info">
              <img 
                src={reel.category_image ? encodeURI(reel.category_image) : '/category-placeholder.png'} 
                alt={reel.category_name || 'Category'}
                className="reel-card-category-icon"
              />
              <h3>{reel.title}</h3>
              {/* <span className="views">👁 {reel.view_count || 0}</span> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
